export function copyToClipboard (text) {
  const textarea = document.createElement('textarea')
  textarea.setAttribute('style', 'position:absolute; left:-1000px')
  textarea.innerHTML = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

export function generateSecureID (length = 5) {
  const chars = 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOPoQqRrSsTtUuVvWwXxYyZz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}
